// Short-lived copies of reference reads (school logo, school years, public settings) that the dashboard
// requests again on navigation. Any mutation from this browser clears every entry, so a user always sees
// their own changes; changes by others appear once an entry expires.
export function createApiResponseCache(now: () => number = Date.now, maxEntries = 100) {
  const entries = new Map<string, { expires: number; value: unknown }>();
  return {
    get<T>(key: string): T | undefined {
      const hit = entries.get(key);
      if (!hit) return undefined;
      if (hit.expires <= now()) { entries.delete(key); return undefined; }
      return structuredClone(hit.value) as T;
    },
    set(key: string, value: unknown, ttlMs: number) {
      entries.delete(key);
      entries.set(key, { expires: now() + ttlMs, value: structuredClone(value) });
      if (entries.size > maxEntries) entries.delete(entries.keys().next().value!);
    },
    clear() { entries.clear(); },
  };
}
